<form class="w-full8" [formGroup]="form">
    <div class="mb-4">
        <div class="flex flex-col gap-2">
            <label for="oldPassword">{{ "fields.oldPasswordLabel" | translate }}*</label>
            <p-password autocomplete="off" fluid formControlName="oldPassword" id="oldPassword" size="large" [feedback]="false" [toggleMask]="true" />
        </div>
    </div>
    <div class="mb-4">
        <div class="flex flex-col gap-2">
            <label for="password">{{ "fields.newPassword" | translate }}*</label>
            <p-password autocomplete="off" fluid formControlName="password" id="password" size="large" [feedback]="false" [toggleMask]="true" />
        </div>
    </div>
    <div class="mb-4">
        <div class="flex flex-col gap-2">
            <label for="passwordRepeat">{{ "fields.repeatNewPassword" | translate }}*</label>
            <p-password autocomplete="off" fluid formControlName="passwordRepeat" id="passwordRepeat" size="large" [feedback]="false" [toggleMask]="true" />
        </div>
    </div>
    <p>
    @if (form.errors?.['passwordMismatch'] && form.touched) {
        <p-message severity="error" size="small" variant="simple">{{ "fields.passwordsValidationSame" | translate }}</p-message>
    }
    </p>
</form>
<div class="flex flex-row items-center mt-4 justify-between w-full">
    <p-button severity="contrast" [label]="'common.cancel' | translate" (click)="closeModal()" />
    <p-button severity="primary" [disabled]="!form.valid" [label]="'common.submit' | translate" (click)="submitClicked()" />
</div>



